import { ErrorBoundary as SentryErrorBoundary } from "@sentry/react";

export const ErrorBoundary = SentryErrorBoundary;
